import { connect } from 'react-redux'
import FrenchMilitaryRecordForm from './FrenchMilitaryRecordForm.jsx'
import {
    getCollaborativeIndexationCampaignDefaultCountry,
    getCollaborativeIndexationCampaignDefaultDepartment,
    getCollaborativeIndexationCreationFields,
    getDefaultEventYear,
    getDefaultMilitaryRecordRegistry,
} from '../../../../../../redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from '../../../../../../redux/collaborativeIndexations/actions'

const mapStateToProps = (state) => ({
    fields: getCollaborativeIndexationCreationFields(state),
    defaultConscriptionYear: getDefaultEventYear(state),
    defaultMilitaryRecordRegistry: getDefaultMilitaryRecordRegistry(state),
    defaultDepartment: getCollaborativeIndexationCampaignDefaultDepartment(state),
    defaultCountry: getCollaborativeIndexationCampaignDefaultCountry(state),
})

const mapDispatchToProps = (dispatch) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
})

export const FrenchMilitaryRecordFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(FrenchMilitaryRecordForm)
